import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import _ from 'lodash';
import { Modal as SemanticModal, } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import { lightenColor, getCssColorFromColorName } from '../../../utils/colors';
import Icon from '../../elementals/icon';
import { ColorNames } from '../../../constants/colorVars';
import styles from './styles.scss';
const cx = classnames.bind(styles);
var ButtonColorNames;
(function (ButtonColorNames) {
    ButtonColorNames["Purple"] = "purple";
    ButtonColorNames["Info"] = "info";
    ButtonColorNames["Error"] = "error";
    ButtonColorNames["Caution"] = "caution";
    ButtonColorNames["Gray"] = "gray";
    ButtonColorNames["Success"] = "success";
})(ButtonColorNames || (ButtonColorNames = {}));
const hasHeader = (children) => Boolean(_.find(React.Children.toArray(children).filter(child => typeof child === 'object' && child !== null), child => _.get(child, 'type.name') === 'Header'));
const Modal = ({ elmId = 'modal', closeIcon, dimmer = true, fullScreen = 'mobileOnly', title, children, mobileTitleSkin = 'dark', gradientSkin = false, gradientColor = ColorNames.Purple, className: modalClassName, size, ...rest }) => {
    const closeIconDefault = (_jsx(Icon, { className: 'close', "data-elm-id": `${elmId}_close_button`, name: 'times', iconStyle: 'regular', fitted: true }));
    const finalCloseIcon = closeIcon !== undefined ? closeIcon : closeIconDefault;
    const backgroundColor = ColorNames.White;
    const gradientColorRaw = getCssColorFromColorName(gradientColor);
    const backgroundColorRaw = getCssColorFromColorName(backgroundColor);
    const lightGradientColor = lightenColor(gradientColorRaw, 50);
    const superLightGradientColor = lightenColor(gradientColorRaw, 80);
    const gradientStyle = !gradientSkin
        ? {}
        : {
            background: `linear-gradient(to bottom, ${backgroundColorRaw}, ${superLightGradientColor}) padding-box, ` +
                `linear-gradient(to bottom, ${lightGradientColor}, ${superLightGradientColor}) border-box`,
        };
    return (_jsxs(SemanticModal, { "data-elm-id": elmId, className: cx('modal', {
            'full-screen-mobile': fullScreen === 'mobileOnly',
            'full-screen-always': fullScreen === 'always',
            'full-screen-never': fullScreen === 'never',
            'mobile-title-dark': mobileTitleSkin === 'dark' && title,
            'gradient-skin': gradientSkin,
            'default-header': !hasHeader(children),
        }, modalClassName), closeIcon: finalCloseIcon, dimmer: dimmer, size: size, style: { ...gradientStyle }, ...rest, children: [title && (_jsx(SemanticModal.Header, { "data-elm-id": `${elmId}_header`, children: title })), children] }));
};
const ModalWithStatic = Modal;
ModalWithStatic.Actions = SemanticModal.Actions;
ModalWithStatic.Content = SemanticModal.Content;
ModalWithStatic.Description = SemanticModal.Description;
ModalWithStatic.Header = SemanticModal.Header;
export * from './actionModalButton';
export default ModalWithStatic;
//# sourceMappingURL=index.js.map